<template>
	<div class="ipt-box">
		<el-input
			class="ipt-search"
			:style="inputStyle"
			:placeholder="placeholder"
			@input="inputHandle"
			@keyup.enter.native="submit"
			v-on="$listeners"
			:value="value"
		>
			<template slot="suffix">
				<div
					class="suffix-box"
					:style="suffixStyle"
					:class="{ 'suffix-hasclear': showClearIcon }"
				>
					<i
						class="el-icon-error box-close"
						v-show="showClearIcon"
						@click.stop="clear"
					></i>
					<div class="box-rig">
						<span class="rig-line"></span>
						<el-button
							type="text"
							@click.stop="submit"
							class="rig-btn"
							>{{ btnText }}</el-button
						>
					</div>
				</div>
			</template>
		</el-input>
	</div>
</template>
<script>
export default {
	props: {
		value: String,
		placeholder: String,
		btnText: {
			type: String,
			default: '搜索',
		},
		width: {
			type: Number,
			default: 248,
		},
		btnWidth: {
			type: Number,
			default: 60,
		},
	},
	computed: {
		showClearIcon() {
			const bool = this.value != '' ? true : false
			return bool
		},
		inputStyle() {
			return {
				'--search-input-width': `${this.width}px`,
				'--search-btn-width': `${this.btnWidth}px`,
				'--search-input-right-padding': `calc(${this.btnWidth}px + ${this.showClearIcon ? 52 : 30}px)`,
			}
		},
		suffixStyle() {
			return {
				width: `${this.btnWidth}px`,
			}
		},
	},
	methods: {
		emitValue(value) {
			this.$emit('input', value)
		},
		inputHandle(value) {
			this.emitValue(value)
			if (value == '') {
				this.clear()
			}
		},
		clear() {
			this.emitValue('')
			this.$emit('clear')
		},
		submit() {
			this.$emit('submit')
		},
	},
}
</script>
<style lang="scss" scoped>
.ipt-box {
	::v-deep .ipt-search {
		width: var(--search-input-width, 248px);
		height: 36px;
		font-size: 14px;
		color: #333333;
		.el-input__inner {
			height: 36px;
			padding: 0 var(--search-input-right-padding, 78px) 0 12px;
		}
		.el-input__suffix-inner {
			width: var(--search-btn-width, 60px);
			height: 100%;
			display: flex;
			align-items: center;
			.suffix-box {
				width: var(--search-btn-width, 60px);
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: flex-end;
				.box-close {
					font-size: 18px;
					cursor: pointer;
				}
				.box-close:hover {
					color: mixin-color(192, 196, 204, 1, 0, 0, 0, 0.2);
				}
				.box-rig {
					display: flex;
					align-items: center;
					.rig-line {
						height: 20px;
						margin-right: 5px;
						border-left: 1px solid #dddddd;
					}
					::v-deep .el-button--text span {
						color: #47b8a0;
					}
					.rig-btn {
						padding: 0;
						font-size: 14px;
						font-weight: bold;
						color: rgb(71, 184, 160) !important;
					}
					.rig-btn:hover {
						color: mixin-color(
							71,
							184,
							160,
							1,
							255,
							255,
							255,
							0.2
						) !important;
					}
					.rig-btn:active {
						color: mixin-color(
							71,
							184,
							160,
							1,
							0,
							0,
							0,
							0.2
						) !important;
					}
				}
			}
			.suffix-hasclear {
				justify-content: space-between;
			}
		}
	}
}
</style>
